// extracted by mini-css-extract-plugin
export default {"news":"NewsLoading_news__zTorQ","image":"NewsLoading_image__fDTSs","placeimage":"NewsLoading_placeimage__XSUVN","title":"NewsLoading_title__3T7E4"};